import React, { useMemo } from "react"
import { useHistory } from "react-router-dom"
import SButton from "components/Common/Button"
import TableContainer from "components/newTables/TableContainer"

const Table = ({ content, page, size, count, setParams, params }) => {
  const history = useHistory()
  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      no: v.id,
      name: v.name,
      craftsmanTypes: v.craftsmanTypes.join(","),
      id: v.id,
    }))
  }, [content])

  const columns = useMemo(
    () => [
      {
        Header: "商品カテゴリ名",
        accessor: "name",
        defaultCanSort: false,
      },
      {
        Header: "職人種類",
        accessor: "craftsmanTypes",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  `/master/product-category/create?id=${cell.row.original.id}`
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  return content?.length === 0 ? (
    <h3 className="text-center">No Data to Display</h3>
  ) : (
    <TableContainer
      params={params}
      setParams={setParams}
      pagination
      page={page}
      size={size}
      count={count}
      columns={columns}
      data={listDataTable}
    />
  )
}

export default Table
